export enum LOCAL_STORAGE {
  unverifiedEmail = 'unverifiedEmail',
  lastUsedEmail = 'lastEmail',
}
